import type { Client } from '@zg-rentals/http-client';
import type { QueryOptions } from '@zg-rentals/react-query5';
import { YourRentalWebApiHandler_getRenterInsuranceUpsell } from '@zg-rentals/ts-your-rental-api-client';

/**
 * Get renter insurance upsell for your rental page with logged-out user
 */
export const getRinsUpsell = (guid: string, httpClient: Client) =>
  ({
    queryKey: ['rins-upsell'],
    queryFn: () => YourRentalWebApiHandler_getRenterInsuranceUpsell({ guid }, httpClient),
    retry: false,
  }) satisfies QueryOptions;
